import cx from 'classnames';

import './LoadingDots.scss';

const LoadingDots = ({ width = '2em', className }) => (
  <span className={cx('LoadingDots', className)} aria-hidden="true">
    <span className="dot-row" style={{ fontSize: width }}>
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </span>
  </span>
);

export default LoadingDots;
